<template>
	<div>
		<!--<div class="clearfix mb-3">
			<h2 class="mb-0">
				{{ $t("files") }}
				<button class="btn btn-primary float-right" @click="openFileUpload">
					<b-icon icon="plus" class="mr-1" />
					{{ $t("upload-files") }}
				</button>
			</h2>
		</div>-->

		<div class="row">
			<div class="col-6 mb-4">
				<h1>{{ $t("files") }}</h1>
			</div>
			<div class="col-6 d-lg-none mb-4">
				<button class="btn btn-primary float-right" @click="openFileUpload" v-if="$UserSession.hasPriv('ASSETS_UPLOAD')">
					<b-icon icon="plus" class="mr-1" />
					{{ $t("upload") }}
				</button>
			</div>
			<div class="d-none d-lg-inline col-6">
				<button
					class="btn btn-primary float-right"
					data-cy="upload-file-button"
					@click="openFileUpload"
					v-if="$UserSession.hasPriv('ASSETS_UPLOAD')"
				>
					<b-icon icon="plus" class="mr-1" />
					{{ $t("upload") }}
				</button>
				<input
					type="search"
					:placeholder="$t('search-files-ellipses')"
					class="block float-right mr-4 form-control inline w-auto"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
			<div class="col-12 d-lg-none mb-4">
				<input
					type="search"
					:placeholder="$t('search-files-ellipses')"
					class="block w-full form-control"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
		</div>

		<div class="inspector-list full-width" v-if="files">
			<InfiniteScroll
				scrollElementId="main"
				type="File"
				:dataUrl="`${$settings.APIBaseURL}/asset/list`"
				dataProperty="results"
				itemClass="inspector-list-item"
				@selectItem="selectFile"
				ref="infinitescroll"
				:noResultsText="$t('no-files-found')"
				containerCyId="files-list"
			/>

			<div class="inspector-list-detail" :class="{ active: selectedFile }">
				<div v-if="selectedFile">
					<div v-if="loadingFile">
						<a
							class="btn btn-light btn-xs float-right ml-3"
							v-on:click="closeView()"
							><b-icon icon="x" width="1em" height="1em"></b-icon>
						</a>
						<h1>{{ $t("loading") }}</h1>
					</div>
					<template v-else class="row">
						<a
							class="btn btn-light btn-xs float-right ml-3"
							v-on:click="closeView()"
							><b-icon icon="x" width="1em" height="1em"></b-icon>
						</a>
						<button
							class="btn btn-secondary justify-center items-center mb-4 mr-2"
							data-cy="toggle-favourite"
							@click="toggleFavourite(selectedFile)"
						>
							<b-icon
								:icon="selectedFile.is_favourite == 1 ? 'heart-fill' : 'heart'"
								data-cy="toggle-favourite-icon"
								class="mr-2"
							/>
							{{ $t("favourite") }}
						</button>
						<a
							class="btn btn-secondary justify-center items-center mb-4 mr-2"
							v-if="getViewURL(selectedFile)"
							:href="getViewURL(selectedFile)"
							target="_blank"
						>
							<b-icon
								icon="eye"
								class="mr-2"
							/>
							{{ $t("view") }}
						</a>
						<button
							class="btn btn-primary justify-center items-center mb-4 mr-2"
							data-cy="download-file-button"
							@click="downloadFile(selectedFile)"
						>
							<b-icon icon="download" class="mr-2" />
							{{ $t("download") }}
						</button>
						<div class="row">
							<div class="col-xs-12 col-md-6">
								<dl>
									<dt class="mb-1">{{ $t("filename") }}</dt>
									<dd class="mb-4">{{ selectedFile.asset_title }}</dd>

									<dt class="mb-1">{{ $t("tags") }}</dt>

									<template v-if="userOwnsFile(selectedFile) && $UserSession.hasPriv('ASSETS_UPLOAD')">
										<dd class="pseudo-input mb-4" data-cy="tags">
											<input
												type="search"
												class="input-bare w-full flex-1"
												data-cy="input-tags"
												:placeholder="`${$t('tags')}:`"
												v-if="
													!selectedFile.tags || !selectedFile.tags.length
												"
												@click="openModal('tags')"
											/>
											<span
												class="badge badge-secondary badge-sm mr-2 mb-2"
												v-for="(tag, index) in selectedFile.tags"
												v-bind:key="index"
											>
												{{ tag.name }}
												<a @click="removeTag(tag)"
													><b-icon icon="x"></b-icon
												></a>
											</span>
											<span
												class="badge badge-primary badge-sm mr-2 mb-2"
												v-if="selectedFile.tags && selectedFile.tags.length"
												@click="openModal('tags')"
											>
												<b-icon icon="plus"></b-icon> {{ $t("add") }}
											</span>
										</dd>
									</template>
									<template v-else>
										<span
											class="badge badge-secondary badge-sm mr-2 mb-2"
											v-for="(tag, index) in selectedFile.tags"
											v-bind:key="index"
										>
											{{ tag.name }}
										</span>
									</template>

									<template v-if="userOwnsFile(selectedFile) && $UserSession.hasPriv('ASSETS_UPLOAD')">
										<dt class="mb-1">{{ $t("shared-with") }}</dt>
										<dd class="pseudo-input mb-4" data-cy="shared-with">
											<input
												type="search"
												class="input-bare w-full flex-1"
												:placeholder="`${$t('shared-with')}:`"
												data-cy="input-shared-with"
												v-if="
													!selectedFile.shared_with ||
														!selectedFile.shared_with.length
												"
												@click="openModal('sharedWith')"
											/>
											<span
												class="badge badge-secondary badge-sm mr-2 mb-2"
												v-for="(recipient,
												index) in selectedFile.shared_with"
												v-bind:key="index"
											>
												{{ recipient.displayName }}
												<a @click="removeRecipient(recipient)"
													><b-icon icon="x"></b-icon
												></a>
											</span>
											<span
												class="badge badge-primary badge-sm mr-2 mb-2"
												v-if="
													selectedFile.shared_with &&
														selectedFile.shared_with.length
												"
												@click="openModal('sharedWith')"
											>
												<b-icon icon="plus"></b-icon> {{ $t("add") }}
											</span>
										</dd>

										<template v-if="canShareWithAll">
											<dt class="mb-1">{{ $t("share-by-role") }}</dt>
											<dd class="pseudo-input mb-4">
												<input
													type="search"
													class="input-bare w-full flex-1"
													data-cy="input-shared-roles"
													placeholder="Roles:"
													v-if="
														!selectedFile.shared_roles ||
															!selectedFile.shared_roles.length
													"
													@click="openModal('shared_roles')"
												/>
												<span
													class="badge badge-secondary badge-sm mr-2 mb-2"
													v-for="(role,
													index) in selectedFile.shared_roles"
													v-bind:key="index"
												>
													{{ role.name }}
													<a @click="removeRole(role)"
														><b-icon icon="x"></b-icon
													></a>
												</span>
												<span
													class="badge badge-primary badge-sm mr-2 mb-2"
													v-if="
														selectedFile.shared_roles &&
															selectedFile.shared_roles.length
													"
													@click="openModal('shared_roles')"
												>
													<b-icon icon="plus"></b-icon> {{ $t("add") }}
												</span>
											</dd>
										</template>
									</template>

									<dt class="mb-1">{{ $t("notes") }}</dt>
									<dd class="mb-4">
										<textarea
											class="form-control w-full mb-2 p-2"
											:placeholder="$t('enter-notes')"
											v-model="selectedFile.asset_note"
											style="height: 140px"
											data-cy="notes-textarea"
											v-if="userOwnsFile(selectedFile) && $UserSession.hasPriv('ASSETS_UPLOAD')"
										></textarea>
										<div style="white-space: pre-wrap" v-else>
											{{ selectedFile.asset_note }}
										</div>
									</dd>

									<template v-if="userOwnsFile(selectedFile)">
										<button
											class="btn btn-secondary mb-8 w-full"
											@click="updateFile(selectedFile)"
											data-cy="update-file-button"
										>
											{{ getUpdateLabel() }}
										</button>

										<button
											class="btn text-danger w-full"
											@click="promptDelete"
											data-cy="delete-file-button"
										>
											<b-icon icon="trash" />
											{{ $t("delete-file") }}
										</button>
									</template>

									<!-- <dt class="mb-1">Comments</dt>
									<dd>
										<div class="flex flex-row mb-4">
											<textarea class="form-control">Enter comment...</textarea>
											<button class="btn btn-secondary">
												<b-icon icon="plus" />
											</button>
										</div>
										<div class="list-group">
											<div class="list-group-item flex flex-row">
												<div class="mr-4">
													<div class="avatar"></div>
												</div>
												<div>
													<div class="flex flex-row justify-between mb-1">
														<p class="font-bold mb-0">Joe Bloggs</p>
														<p class="mb-0">
															<b-icon icon="clock" class="mr-1" /> 2 hours
															ago
														</p>
													</div>
													<p class="mb-0">
														Quisque ornare nec nibh eu fringilla. Aenean
														vulputate nisi feugiat leo tincidunt, at
														venenatis massa eleifend.
													</p>
												</div>
											</div>

											<div class="list-group-item flex flex-row">
												<div class="mr-4">
													<div class="avatar"></div>
												</div>
												<div>
													<div class="flex flex-row justify-between mb-1">
														<p class="font-bold mb-0">Joe Bloggs</p>
														<p class="mb-0">
															<b-icon icon="clock" class="mr-1" /> 2 hours
															ago
														</p>
													</div>
													<p class="mb-0">
														Quisque ornare nec nibh eu fringilla. Aenean
														vulputate nisi feugiat leo tincidunt, at
														venenatis massa eleifend.
													</p>
												</div>
											</div>

											<div class="list-group-item flex flex-row">
												<div class="mr-4">
													<div class="avatar"></div>
												</div>
												<div>
													<div class="flex flex-row justify-between mb-1">
														<p class="font-bold mb-0">Joe Bloggs</p>
														<p class="mb-0">
															<b-icon icon="clock" class="mr-1" /> 2 hours
															ago
														</p>
													</div>
													<p class="mb-0">
														Quisque ornare nec nibh eu fringilla. Aenean
														vulputate nisi feugiat leo tincidunt, at
														venenatis massa eleifend.
													</p>
												</div>
											</div>
										</div>
									</dd> -->
								</dl>
							</div>

							<div class="col-xs-12 col-md-6">
								<img
									class="w-full"
									v-if="getFetchURL(selectedFile)"
									:src="getFetchURL(selectedFile)"
								/>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";
export default {
	components: {
		InfiniteScroll
	},
	data: function() {
		return {
			// recipients: [],
			// tags: [],
			// notes: "",
			saving: false,
			saved: false,
			selectedFile: null,
			selectedFileId: null,
			loadingFile: false,
			files: [],
			searchTerm: null,
			searchTimer: null
		};
	},
	mounted() {
		// teachers can message students and teachers
		// students can only message teachers
		const promises = [this.$users.getTeachers.call(this)];
		if (this.canShareWithAll) {
			// should we use a new/different priv here instead?
			promises.push(this.$users.getStudents.call(this));
		}
		Promise.all(promises).then(values => {
			// merge teacher/student arrays
			this.users = [].concat.apply([], values);
		});

		this.$cfetch(`${this.$settings.APIBaseURL}/asset/list`)
			.then(res => {
				this.files = res.results;
			})
			.catch(err => {
				this.$log.error.call(this, err);
			});

		this.getFiles();
	},
	methods: {
		userOwnsFile(file) {
			return file.user_id == this.$UserSession.getValue("id");
		},
		getFiles() {
			const body = {};
			if (this.searchTerm) {
				body.q = this.searchTerm;
			}
			this.$refs.infinitescroll.getData("replace", body);
		},
		searchTermChange() {
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			this.searchTimer = setTimeout(() => {
				this.getFiles();
			}, 500);
		},
		selected(file) {
			return this.selectedFile && this.selectedFile.asset_id == file.id;
		},
		selectFile(file) {
			this.loadingFile = true;
			this.selectedFile = file;

			this.$cfetch(`${this.$settings.APIBaseURL}/asset/get`, {
				method: "get",
				data: {
					asset_id: file.asset_id
				}
			})
				.then(res => {
					this.$set(this.selectedFile, "shared_with", res.result.shared_with);
					this.$set(this.selectedFile, "shared_roles", res.result.shared_roles);
					this.$set(this.selectedFile, "tags", res.result.tags);

					this.loadingFile = false;
				})
				.catch(err => {
					this.$log.error.call(this, err);
				});
		},
		getFileIcon(fileName) {
			const fileNameArr = fileName.split(".");

			if (fileNameArr[1].toLowerCase() === "pdf") {
				return "file-earmark-richtext";
			}

			if (fileNameArr[1].toLowerCase() === "doc" || fileNameArr[1].toLowerCase() === "docx") {
				return "file-earmark-word";
			}

			if (
				fileNameArr[1].toLowerCase() === "jpeg" ||
				fileNameArr[1].toLowerCase() === "jpg" ||
				fileNameArr[1].toLowerCase() === "gif" ||
				fileNameArr[1].toLowerCase() === "png"
			) {
				return "file-earmark-image";
			}

			return "file-earmark";
		},
		getIconColor(fileName) {
			const fileNameArr = fileName.split(".");

			if (fileNameArr[1].toLowerCase() === "pdf") {
				return "file-icon file-icon-pdf mr-2";
			}

			if (fileNameArr[1].toLowerCase() === "doc" || fileNameArr[1].toLowerCase() === "docx") {
				return "file-icon file-icon-word mr-2";
			}

			if (
				fileNameArr[1].toLowerCase() === "jpeg" ||
				fileNameArr[1].toLowerCase() === "jpg" ||
				fileNameArr[1].toLowerCase() === "gif" ||
				fileNameArr[1].toLowerCase() === "png"
			) {
				return "file-icon file-icon-image mr-2";
			}

			return "file-icon file-icon-default mr-2";
		},
		getFileType(fileName) {
			const fileNameArr = fileName.split(".");

			if (fileNameArr[1].toLowerCase() === "pdf") {
				return this.$t('pdf');
			}

			if (fileNameArr[1].toLowerCase() === "doc" || fileNameArr[1].toLowerCase() === "docx") {
				return this.$t('word-document');
			}

			if (
				fileNameArr[1].toLowerCase() === "jpeg" ||
				fileNameArr[1].toLowerCase() === "jpg" ||
				fileNameArr[1].toLowerCase() === "gif" ||
				fileNameArr[1].toLowerCase() === "png"
			) {
				return this.$t('image');
			}

			return this.$t('file');
		},
		openFileUpload() {
			const self = this;
			this.$store.commit("openModal", {
				type: "fileUpload",
				// title: this.$t("select-a-student")
				title: this.$t('upload-file(s)'),
				uploadCallback: function() {
					self.getFiles();
				}
			});
		},
		addRecipientsBy(key, value) {
			this.recipients = [
				...this.recipients,
				...this.users.filter(
					user =>
						user[key] === value && // filter by key/value
						!this.recipients.some(
							recipient => recipient.id == user.id // don't add recipients that have already been added
						)
				)
			];
		},
		openModal(modalType) {
			const self = this;

			if (modalType === "tags") {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-tags"),
					selectCallback: function(selection) {
						const isSelected = self.selectedFile.tags.find((tag, i) => {
							if (tag.id === selection.id) {
								self.$delete(self.selectedFile.tags, i);
								return true;
							}
						});
						if (!isSelected) {
							self.selectedFile.tags.push(selection);
						}
					},
					selected: this.selectedFile.tags,
					data: this.$config.getValue("tags"),
					captionKey: "name"
				});
			}

			if (modalType === "sharedWith") {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-recipients"),
					selectCallback: function(selection) {
						const isSelected = self.selectedFile.shared_with.find((recipient, i) => {
							if (recipient.id === selection.id) {
								self.$delete(self.selectedFile.shared_with, i);
								return true;
							}
						});
						if (!isSelected) {
							self.selectedFile.shared_with.push(selection);
						}
					},
					selected: this.selectedFile.shared_with,
					data: this.users,
					captionKey: "displayName",
					studentSearchFilters: this.canShareWithAll,
					selectAllBtn: this.canShareWithAll
				});
			}

			if (modalType === "shared_roles") {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("Select Groups"),
					selectCallback: function(selection) {
						const isSelected = self.selectedFile.shared_roles.find((role, i) => {
							if (role.id === selection.id) {
								self.$delete(self.selectedFile.shared_roles, i);
								return true;
							}
						});
						if (!isSelected) {
							self.selectedFile.shared_roles.push(selection);
						}
					},
					selected: this.selectedFile.shared_roles,
					data: this.$config.getValue("roles"),
					captionKey: "name"
				});
			}
		},
		removeTag(selection) {
			const self = this;
			self.selectedFile.tags.find((tag, i) => {
				if (tag.id === selection.id) {
					self.$delete(self.selectedFile.tags, i);
					return true;
				}
			});
			return false;
		},
		removeRecipient(selection) {
			const self = this;
			self.selectedFile.shared_with.find((student, i) => {
				if (student.id === selection.id) {
					self.$delete(self.selectedFile.shared_with, i);
					return true;
				}
			});
			return false;
		},
		getUpdateLabel() {
			if (this.saving) {
				return "Saving...";
			}

			if (this.saved) {
				return "Saved!";
			}

			return "Save";
		},
		downloadFile(file) {
			window.open(
				`${this.$settings.APIBaseURL}/asset/download/${file.asset_id}.${
					file.asset_extension
				}?username=${this.$UserSession.getValue.call(
					this,
					"username"
				)}&authToken=${this.$UserSession.getValue.call(this, "authToken")}`
			);
		},
		getFetchURL(file) {
			if (
				file.asset_extension == "jpg" ||
				file.asset_extension == "jpeg" ||
				file.asset_extension == "png" ||
				file.asset_extension == "gif"
			) {
				return `${this.$settings.APIBaseURL}/asset/fetch/${file.asset_id}.${
					file.asset_extension
				}?username=${this.$UserSession.getValue.call(
					this,
					"username"
				)}&authToken=${this.$UserSession.getValue.call(this, "authToken")}`;
			}
			return null;
		},
		getViewURL(file) {
			if (
				file.asset_extension == "jpg" ||
				file.asset_extension == "jpeg" ||
				file.asset_extension == "png" ||
				file.asset_extension == "gif" ||
				file.asset_extension == "pdf"
			) {
				return `${this.$settings.APIBaseURL}/asset/fetch/${file.asset_id}.${
					file.asset_extension
				}?username=${this.$UserSession.getValue.call(
					this,
					"username"
				)}&authToken=${this.$UserSession.getValue.call(this, "authToken")}`;
			}
			return null;
		},
		toggleFavourite(file) {
			file.is_favourite = file.is_favourite === "1" ? "0" : "1";
			this.$cfetch(`${this.$settings.APIBaseURL}/asset/favourite`, {
				method: "post",
				data: {
					asset_id: file.asset_id,
					favourite: file.is_favourite
				}
			});
		},
		closeView() {
			this.selectedFile = null;
		},
		updateFile() {
			this.saving = true;
			this.$cfetch(`${this.$settings.APIBaseURL}/asset/update`, {
				method: "post",
				data: {
					asset_id: this.selectedFile.asset_id,
					asset_islibraryitem: this.selectedFile.asset_islibraryitem,
					asset_title: this.selectedFile.asset_title,
					asset_note: this.selectedFile.asset_note,
					shareduser_id: this.selectedFile.shared_with.map(user => Number(user.id)),
					sharedrole_id: this.selectedFile.shared_roles.map(role => Number(role.id)),
					tag_id: this.selectedFile.tags.map(tag => Number(tag.id))
				}
			})
				.then(res => {
					this.saving = false;
					this.saved = true;
					// this.selectedFile = res.result;
					// this.$set(this.selectedFile, "shared_with", res.result.shared_with);
					//console.log("res", res);
					this.$set(this.selectedFile, "shared_with", res.result.shared_with);
					this.$set(this.selectedFile, "shared_roles", res.result.shared_roles);
					this.$set(this.selectedFile, "tags", res.result.tags);
					this.$set(this.selectedFile, "asset_title", res.result.asset.asset_title);
					this.$set(this.selectedFile, "asset_note", res.result.asset.asset_note);

					setTimeout(() => {
						this.saved = false;
					}, 1000);
				})
				.catch(err => {
					this.$log.error.call(this, err);
					this.saving = false;
					this.saved = false;
				});
		},
		confirmDelete() {
			//console.log("confirm delete", this.selectedFile);
			const self = this;
			this.$cfetch(`${this.$settings.APIBaseURL}/asset/delete`, {
				method: "post",
				data: {
					asset_id: this.selectedFile.asset_id
				}
			}).then(res => {
				//console.log("res", res);
				if (res.status === "SUCCESS") {
					self.getFiles();
					self.selectedFileId = null;
					self.selectedFile = null;
				}
			});
		},
		promptDelete() {
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t('delete-file'),
				htmlContent: `<p>${this.$t('are-you-sure-delete-file')}</p>`,
				size: "md",
				confirmCallBack: () => this.confirmDelete()
			});
		}
	},
	computed: {
		canShareWithAll() {
			return this.$UserSession.hasPriv("APP_ALLSTUDENTS");
		}
	}
};
</script>
